<div id="admin-questionnarie-create" class="page-layout carded  fullwidth" fxLayout="column">
  <ngx-loading [show]="loading"></ngx-loading>
  <!-- HEADER -->
  <div class="header accent p-24 h-70" fxLayout="row" fxLayoutAlign="start center">
    <div fxLayout="column" fxLayoutAlign="center start">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="secondary-text s-18">home</mat-icon>
        <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
        <span class="secondary-text">Chestionare</span>
        <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
        <span class="secondary-text" *ngIf="uid">Chestionar: {{questionnaire.name}}</span>
        <span class="secondary-text" *ngIf="resultUid">Rezultate: {{questionnaire.name}}</span>
      </div>

      <div class="h1 mt-16">Chestionar:  {{questionnaire.name}}</div>
    </div>
   </div>

  <!-- / HEADER -->

  <div class="content p-24">
    <div class="mat-elevation-z8">
      <div style="max-width: 100%!important;">

        <mat-card fxFlex="100" class="mt-10">

          <mat-card-content>

            <div class="h1 mt-16" *ngIf="resultUid">
              Rezultat chestionar:  <b>{{questionnaire.name}}</b> pentru utilizatorul:  <b>{{ (resultForUser) ? resultForUser.name : ' -- ' }}</b>
              in data <b>{{resultDate | date: 'dd-MM-yyyy HH:mm'}}</b>
            </div>

            <show-question-row class="p-24 mb-4" fxLayout="row" style="width: 100%!important"
                               *ngFor="let question of questionnaire.questions"
                               [question]="question"
                               [resultMode]="(resultUid) ? true : false"
                               (updateQuestionEvent)="onUpdateQuestion($event)">
            </show-question-row>
          </mat-card-content>

          <mat-card-actions style="text-align: right; padding: 10px">
            <button mat-raised-button color="accent" (click)="onSaveQuestionnaire()">Salveaza</button>
          </mat-card-actions>

        </mat-card>

      </div>
    </div>
  </div>

</div>
